// extracted by mini-css-extract-plugin
module.exports = {"content":"AccountActionsConfirmDialog_content__ixT38"};